import React from 'react';
import PropTypes from 'prop-types';
import { setClassNames } from '@ddc/classnames-js';

const PlaceholderImage = ({ index, className }) => (
	<div
		className={setClassNames(['bg-contrast-med', className])}
		data-testid={`vehicle-images-placeholder-${index}`}
		aria-hidden="true"
		style={{
			aspectRatio: '16 / 9',
			width: '100%',
			backgroundClip: 'content-box'
		}}
	/>
);

PlaceholderImage.propTypes = {
	index: PropTypes.number.isRequired,
	className: PropTypes.string
};

export default PlaceholderImage;
